import * as Lucide from "lucide-react";

// Render a lucide icon by name (from site data). Falls back to a dot.
export const Icon = ({ name, className = "h-5 w-5", strokeWidth = 1.75 }) => {
  const Cmp = Lucide[name] || Lucide.Circle;
  return <Cmp className={className} strokeWidth={strokeWidth} />;
};

export const SectionLabel = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs font-semibold uppercase tracking-widest ${
      dark
        ? "border-white/15 bg-white/5 text-white/70"
        : "border-brand/15 bg-brand/5 text-brand"
    }`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-greenaccent" />
    {children}
  </span>
);
